import { __decorate, __metadata } from "tslib";
import { ImageFrame } from './ImageFrame';
import { LengthUnit, SerializableMember, SerializableObject } from '@openhps/core';
let DepthImageFrame = class DepthImageFrame extends ImageFrame {
};
__decorate([
    SerializableMember(),
    __metadata("design:type", Object)
], DepthImageFrame.prototype, "depth", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", LengthUnit)
], DepthImageFrame.prototype, "depthUnit", void 0);
DepthImageFrame = __decorate([
    SerializableObject()
], DepthImageFrame);
export { DepthImageFrame };
//# sourceMappingURL=DepthImageFrame.js.map